export const BOARD_CHAT_ROUTE = '/app/chat';

export const BOARD_CHAT_LAYOUTS = {
  modal: 'modal',
  fullscreen: 'fullscreen',
  sidebar: 'sidebar',
};

export const BOARD_CHAT_LAYOUT_DEFAULT = BOARD_CHAT_LAYOUTS.modal;

const STORAGE_KEY = 'painelOs.boardChat.layout';
export const BOARD_CHAT_OPEN_SIDEBAR_EVENT = 'painel-os-board-chat-open-sidebar';
export const BOARD_CHAT_OPEN_EVENT = 'painel-os-board-chat-open';

export function isBoardChatLayout(value) {
  return (
    value === BOARD_CHAT_LAYOUTS.modal ||
    value === BOARD_CHAT_LAYOUTS.fullscreen ||
    value === BOARD_CHAT_LAYOUTS.sidebar
  );
}

export function getBoardChatLayout() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (isBoardChatLayout(raw)) return raw;
  } catch {
    /* ignore */
  }
  return BOARD_CHAT_LAYOUT_DEFAULT;
}

export function setBoardChatLayout(layout) {
  const next = isBoardChatLayout(layout) ? layout : BOARD_CHAT_LAYOUT_DEFAULT;
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}

export function requestBoardChatSidebarOpen() {
  try {
    sessionStorage.setItem('painelOs.boardChat.openSidebar', '1');
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(BOARD_CHAT_OPEN_SIDEBAR_EVENT));
}

export function consumeBoardChatSidebarOpenFlag() {
  try {
    if (sessionStorage.getItem('painelOs.boardChat.openSidebar') === '1') {
      sessionStorage.removeItem('painelOs.boardChat.openSidebar');
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

/** Abre o chat sobre o Board; a URL /app/chat é sincronizada pelo toolbar. */
export function requestBoardChatOpen(layout) {
  const next = isBoardChatLayout(layout) ? layout : getBoardChatLayout();
  try {
    sessionStorage.setItem('painelOs.boardChat.openLayout', next);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(BOARD_CHAT_OPEN_EVENT, { detail: { layout: next } }));
}

export function consumeBoardChatOpenLayout() {
  try {
    const raw = sessionStorage.getItem('painelOs.boardChat.openLayout');
    if (raw) {
      sessionStorage.removeItem('painelOs.boardChat.openLayout');
      if (isBoardChatLayout(raw)) return raw;
    }
  } catch {
    /* ignore */
  }
  return null;
}
